<button
  [class.icon-button]="text === ''"
  [disabled]="disabled"
  [ngClass]="['custom-button', type, size, width, buttonClass]"
  [type]="isSubmit ? 'submit' : 'button'">
  @if (iconPosition && iconPosition === 'left' && (icon !== '' || svgIcon)) {
    <mat-icon class="icon-s button-icon" svgIcon="{{ svgIcon }}">{{ icon }}</mat-icon>
  }
  @if (text !== '') {
    <p [class]="buttonTextSize">{{ text }}</p>
  }
  @if (iconPosition === 'right' && (icon !== '' || svgIcon)) {
    @if (notification !== null) {
      <mat-icon
        [matBadge]="notification"
        class="icon-s button-icon"
        matBadgePosition="below after"
        aria-hidden="false"
        svgIcon="{{ svgIcon }}">
        {{ icon }}
      </mat-icon>
    } @else {
      <mat-icon class="icon-s button-icon" svgIcon="{{ svgIcon }}">
        {{ icon }}
      </mat-icon>
    }
  }
</button>
